// this is an autogenerated file from DesignSystem/ImageCard/Content/Content/Actions/Launchers/Content/App/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_ImageCard_Content_Content_Actions_Launchers_Content_App(
  $id: String!
  $resource_id: uuid!
  $location_id: uuid!
) {
  apps_launchers_resolve(
    id: $id
    resource_id: $resource_id
    location_id: $location_id
  ) {
    ok
    url
    component
    message
  }
}

`